import { render, staticRenderFns } from "./InformationsAchat.vue?vue&type=template&id=6c63998e"
import script from "./InformationsAchat.vue?vue&type=script&lang=js"
export * from "./InformationsAchat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports